<section
  class="home-pasos"
  [attr.id]="anchorId"
  aria-labelledby="home-pasos-title"
>
  <div class="home-pasos__inner">
    <div class="home-pasos__heading">
      <p class="home-pasos__eyebrow">{{ content.eyebrow }}</p>
      <h2 id="home-pasos-title" class="home-pasos__title" [innerHTML]="titleSafe"></h2>
    </div>

    <div class="home-pasos__layout">
      <ol class="home-pasos__list">
        @for (item of content.items; track $index; let i = $index) {
        <li class="home-pasos__item">
          <span class="home-pasos__number" aria-hidden="true">{{ i + 1 }}</span>
          <div class="home-pasos__item-content">
            <h3 class="home-pasos__item-title">{{ item.title }}</h3>
            <p class="home-pasos__item-text">{{ item.description }}</p>
          </div>
        </li>
        }
      </ol>

      <div class="home-pasos__mockup" aria-hidden="true">
        <div class="home-pasos__mockup-picture">
          <img
            class="home-pasos__mockup-image"
            [src]="content.imageDesktopSrc"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</section>
